import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRobot } from '@fortawesome/free-solid-svg-icons';

/**
 * Shown while the assistant is working: a search, a filter change, an answer on its way. A bot in a turning ring,
 * with three dots behind it that rise one after the other. Icon only - the word is there for screen readers.
 * (A plain robot, not the "bots" logo of the tab: that one is a wordmark and would read as text at this size.)
 * The motion is in shared/assistant.scss and is switched off for visitors who ask their system for less of it.
 */
const AssistantLoader: FC = () => {
  const { t } = useTranslation();

  return (
    <span className="assistant-loader" role="status" aria-live="polite">
      <span className="assistant-loader-orb" aria-hidden="true">
        <FontAwesomeIcon icon={faRobot} />
      </span>
      <span className="assistant-loader-dots" aria-hidden="true">
        <span />
        <span />
        <span />
      </span>
      <span className="assistant-sr-only">{t('assistant.loading')}</span>
    </span>
  );
};

export default AssistantLoader;
